/* ==========================================================================
   Lockett Labs collection page (sections/static-collection.liquid)

   Part 1 was the section's inline script (44 KB on every collection view),
   moved here unchanged so it is cached and deferred. Part 2 is the 2026
   overhaul: grid/list view, the set drawer, the active filter pills, the live
   masthead numbers and the lazy Discord count.
   ========================================================================== */
(function () {
  /* The section id, read from the section root rather than printed into an
     inline script: this file is cached across every collection page. */
  var ROOT_ID = (function () {
    var r = document.querySelector('[data-llc-root]');
    return r ? r.getAttribute('data-section-id') : '';
  }());
  var WKEY = 'll_watchlist';
  var WKEY_LEGACY = 'll_preorder_watch';

  function closestEl(from, sel) {
    var n = from;
    if (!n) return null;
    if (n.nodeType === 3) n = n.parentElement;
    if (!n || typeof n.closest !== 'function') return null;
    try { return n.closest(sel); } catch (err) { return null; }
  }

  function rootOf(el) {
    return closestEl(el, '[data-llc-root]') || document.querySelector('[data-llc-root][data-section-id="' + ROOT_ID + '"]') || document.querySelector('[data-llc-root]');
  }

  function cartRootUrl() {
    return (window.Shopify && Shopify.routes && Shopify.routes.root) ? Shopify.routes.root : '/';
  }

  function readWatch() {
    try {
      var list = JSON.parse(localStorage.getItem(WKEY) || 'null');
      if (Object.prototype.toString.call(list) === '[object Array]') return list;
      var old = JSON.parse(localStorage.getItem(WKEY_LEGACY) || '[]') || [];
      if (Object.prototype.toString.call(old) === '[object Array]' && old.length) {
        writeWatch(old); return old;
      }
    } catch (e) {}
    return [];
  }

  function writeWatch(list) {
    var clean = [];
    try {
      (list || []).forEach(function (h) { if (h && clean.indexOf(h) < 0) clean.push(h); });
      clean = clean.slice(0, 100);
      localStorage.setItem(WKEY, JSON.stringify(clean));
      localStorage.setItem(WKEY_LEGACY, JSON.stringify(clean));
      try { document.dispatchEvent(new CustomEvent('ll:watchlist:change', { detail: { list: clean } })); } catch (e2) {}
      try {
        if (window.LLWatchlistLive && typeof window.LLWatchlistLive.refresh === 'function') {
          window.LLWatchlistLive.refresh();
        }
      } catch (e3) {}
    } catch (e) {}
    return clean;
  }

  function unwatchHandle(handle) {
    var list = readWatch().filter(function (h) { return h !== handle; });
    writeWatch(list);
    try {
      var snaps = JSON.parse(localStorage.getItem('ll_watchlist_snap') || '{}') || {};
      delete snaps[handle];
      localStorage.setItem('ll_watchlist_snap', JSON.stringify(snaps));
    } catch (e) {}
    try {
      if (window.LLWatchlistLive && typeof window.LLWatchlistLive.stop === 'function') {
        window.LLWatchlistLive.stop(handle);
      }
    } catch (e4) {}
    return list;
  }

  function ensureToast(root) {
    if (!root) return null;
    var toast = document.querySelector('.llc-toast-' + ROOT_ID) || root.querySelector('[data-toast]');
    if (!toast) return null;
    if (toast.parentNode !== document.body) {
      toast.classList.add('llc-toast-' + ROOT_ID);
      document.body.appendChild(toast);
    }
    return toast;
  }

  function showToast(root, msg, href, linkText) {
    var toast = ensureToast(root);
    var live = root && root.querySelector('[data-live]');
    if (live) live.textContent = msg || '';
    if (!toast) return;
    var toastText = toast.querySelector('[data-toast-text]');
    var toastLink = toast.querySelector('[data-toast-link]');
    if (toastText) toastText.textContent = msg || '';
    if (toastLink) {
      if (href) {
        toastLink.href = href;
        toastLink.textContent = linkText || 'View watchlist';
        toastLink.hidden = false;
      } else {
        toastLink.hidden = true;
      }
    }
    toast.classList.add('is-on');
    clearTimeout(toast._llcTimer);
    toast._llcTimer = setTimeout(function () { toast.classList.remove('is-on'); }, 4000);
  }

  function watchHas(list, handle) {
    if (!handle || !list || !list.length) return false;
    for (var i = 0; i < list.length; i++) {
      var h = typeof list[i] === 'string' ? list[i] : (list[i] && list[i].handle);
      if (h === handle) return true;
    }
    return false;
  }

  function ctaLabels(btn) {
    return {
      add: btn.getAttribute('data-watch-add') || 'Watch for alerts',
      addShort: btn.getAttribute('data-watch-add-short') || 'Watch',
      remove: btn.getAttribute('data-watch-remove') || 'Remove from Watchlist',
      removeShort: btn.getAttribute('data-watch-remove-short') || 'Unwatch'
    };
  }

  function setCtaLabel(btn, fullText, shortText) {
    if (!btn) return;
    btn.innerHTML = '<span class="llc__btn-full"></span><span class="llc__btn-short"></span>';
    var full = btn.querySelector('.llc__btn-full');
    var short = btn.querySelector('.llc__btn-short');
    if (full) full.textContent = fullText || '';
    if (short) short.textContent = shortText || fullText || '';
  }

  function paintWatchCta(btn, on, flash) {
    if (!btn) return;
    var labels = ctaLabels(btn);
    btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    btn.classList.toggle('is-watching', !!on);
    if (flash === 'saved') {
      btn.classList.add('is-watch-ok');
      setCtaLabel(btn, 'Saved', 'Saved');
      clearTimeout(btn._llcWatchFlash);
      btn._llcWatchFlash = setTimeout(function () {
        btn.classList.remove('is-watch-ok');
        setCtaLabel(btn, labels.remove, labels.removeShort);
      }, 700);
      return;
    }
    if (flash === 'removed') {
      btn.classList.add('is-watch-ok');
      setCtaLabel(btn, 'Removed', 'Removed');
      clearTimeout(btn._llcWatchFlash);
      btn._llcWatchFlash = setTimeout(function () {
        btn.classList.remove('is-watch-ok');
        setCtaLabel(btn, labels.add, labels.addShort);
      }, 700);
      return;
    }
    clearTimeout(btn._llcWatchFlash);
    btn.classList.remove('is-watch-ok');
    if (on) setCtaLabel(btn, labels.remove, labels.removeShort);
    else setCtaLabel(btn, labels.add, labels.addShort);
  }

  function paintWatch(root, opts) {
    opts = opts || {};
    root = root || document.querySelector('[data-llc-root][data-section-id="' + ROOT_ID + '"]') || document.querySelector('[data-llc-root]');
    if (!root) return;
    var list = readWatch();
    var flashHandle = opts.flashHandle || '';
    var flashKind = opts.flashKind || '';
    root.querySelectorAll('.llc__bell[data-watch]').forEach(function (bell) {
      var handle = bell.getAttribute('data-handle');
      if (!handle) {
        var card = bell.closest('[data-card]');
        handle = card && card.getAttribute('data-handle');
      }
      bell.setAttribute('aria-pressed', watchHas(list, handle) ? 'true' : 'false');
      if (handle) {
        bell.setAttribute('aria-label', watchHas(list, handle) ? 'Remove from watchlist' : 'Watch for alerts');
      }
    });
    root.querySelectorAll('[data-watch-cta]').forEach(function (btn) {
      var handle = btn.getAttribute('data-handle');
      if (!handle) {
        var card = btn.closest('[data-card]');
        handle = card && card.getAttribute('data-handle');
        if (handle) btn.setAttribute('data-handle', handle);
      }
      var on = watchHas(list, handle);
      var flash = (flashHandle && handle === flashHandle) ? flashKind : '';
      paintWatchCta(btn, on, flash);
    });
    var watchChip = root.querySelector('[data-watch-chip]');
    var watchCount = root.querySelector('[data-watch-count]');
    var total = list.length;
    if (watchChip) {
      watchChip.hidden = total === 0;
      watchChip.setAttribute('data-has', total ? '1' : '0');
      if (watchCount) watchCount.textContent = String(total);
    }
    var watchPageLink = root.querySelector('[data-watch-page-link]');
    if (watchPageLink) {
      var chipN = watchPageLink.querySelector('[data-chip-n]');
      if (chipN) chipN.textContent = total ? ' ' + total : '';
      watchPageLink.hidden = total === 0;
      watchPageLink.style.display = total ? '' : 'none';
    }
    try {
      if (typeof root._llcApplyFilter === 'function') root._llcApplyFilter();
    } catch (e) {}
  }

  function toggleWatch(el) {
    var root = rootOf(el);
    var handle = el.getAttribute('data-handle');
    if (!handle) {
      var card = closestEl(el, '[data-card]');
      handle = card && card.getAttribute('data-handle');
    }
    if (!handle) return false;
    var list = readWatch();
    var watchUrl = (root && root.getAttribute('data-watch-url')) || '/pages/watchlist';
    if (watchHas(list, handle)) {
      unwatchHandle(handle);
      paintWatch(root, { flashHandle: handle, flashKind: 'removed' });
      showToast(root, 'Removed from your watchlist');
    } else {
      list.unshift(handle);
      writeWatch(list);
      paintWatch(root, { flashHandle: handle, flashKind: 'saved' });
      var msg = (root && root.getAttribute('data-toast-watch')) || 'Saved to your watchlist';
      if (/discord/i.test(msg)) msg = 'Saved to your watchlist';
      showToast(root, msg, watchUrl, 'View watchlist');
    }
    return false;
  }

  function bumpCartCount() {
    fetch(cartRootUrl() + 'cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var n = cart && cart.item_count != null ? cart.item_count : null;
        if (n == null) return;
        document.querySelectorAll('[data-cart-count], .cart-count, .cart-link__count, .header__cart-count, .site-header__cart-count, .js-cart-count').forEach(function (el) {
          el.textContent = String(n);
          el.hidden = n === 0;
          if (el.setAttribute) el.setAttribute('data-count', String(n));
        });
        try {
          document.dispatchEvent(new CustomEvent('ll:cart:updated', { detail: cart }));
        } catch (err) {}
      })
      .catch(function () {});
  }

  function addToCart(btn) {
    var root = rootOf(btn);
    var id = btn.getAttribute('data-atc');
    if (!id) return false;
    var labelFull = 'Add to cart';
    var labelShort = 'Add';
    var fullEl = btn.querySelector('.llc__btn-full');
    var shortEl = btn.querySelector('.llc__btn-short');
    if (fullEl) labelFull = fullEl.textContent || labelFull;
    if (shortEl) labelShort = shortEl.textContent || labelShort;
    else labelShort = labelFull;
    btn.classList.add('is-busy');
    btn.disabled = true;
    var payload = { id: Number(id), quantity: 1 };
    if (btn.getAttribute('data-preorder') === '1' && btn.getAttribute('data-release')) {
      payload.properties = { 'Pre-order release': btn.getAttribute('data-release') };
    }
    var cartUrl = (root && root.getAttribute('data-cart-url')) || '/cart';
    fetch(cartRootUrl() + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify(payload)
    }).then(function (r) {
      return r.json().then(function (j) { return { ok: r.ok, json: j }; }).catch(function () {
        return { ok: r.ok, json: {} };
      });
    }).then(function (res) {
      if (!res.ok) throw new Error((res.json && (res.json.description || res.json.message)) || 'Could not add');
      btn.classList.remove('is-busy');
      btn.classList.add('is-added');
      setCtaLabel(btn, 'Added', 'Added');
      showToast(root, (root && root.getAttribute('data-toast-added')) || 'Added to your cart', cartUrl, 'View cart');
      bumpCartCount();
      setTimeout(function () {
        btn.classList.remove('is-added');
        setCtaLabel(btn, labelFull, labelShort);
        btn.disabled = false;
      }, 1600);
    }).catch(function (err) {
      btn.classList.remove('is-busy');
      btn.disabled = false;
      setCtaLabel(btn, labelFull, labelShort);
      showToast(root, (err && err.message) || 'Sorry, that could not be added');
    });
    return false;
  }


  var _llcFetching = false;
  function absoluteUrl(href) {
    try {
      var u = new URL(href, window.location.origin);
      var cur = new URL(window.location.href);
      /* Theme preview / customizer: keep preview params or AJAX loads the live theme (no LLC). */
      ['preview_theme_id', 'preview_theme', 'key', '_fd', 'pb'].forEach(function (k) {
        var v = cur.searchParams.get(k);
        if (v && !u.searchParams.get(k)) u.searchParams.set(k, v);
      });
      return u.toString();
    } catch (e) { return href; }
  }
  function extractSwapHtml(html) {
    if (!html) return null;
    /* String extract first — Pokémon full pages are huge; DOMParser can fail/omit nodes. */
    var marker = html.indexOf('data-llc-swap');
    if (marker >= 0) {
      var openEnd = html.indexOf('>', marker);
      if (openEnd > 0) {
        var closeMark = html.indexOf('/data-llc-swap', openEnd);
        if (closeMark > openEnd) {
          var closeDiv = html.lastIndexOf('</div>', closeMark);
          if (closeDiv > openEnd) return html.slice(openEnd + 1, closeDiv);
        }
        var rootClose = html.indexOf('data-llc-root', openEnd);
        /* fallback: slice until llc__seo or end of section script */
        var cut = html.search(/class="llc__seo"|id="shopify-section-/);
        if (cut > openEnd) {
          var last = html.lastIndexOf('</div>', cut);
          if (last > openEnd) return html.slice(openEnd + 1, last);
        }
      }
    }
    try {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var incomingRoot = doc.querySelector('[data-llc-root]') || doc.body;
      var incomingSwap = incomingRoot.querySelector('[data-llc-swap]');
      if (incomingSwap) return incomingSwap.innerHTML;
      var formats = incomingRoot.querySelector('.llc__formats');
      var layout = incomingRoot.querySelector('.llc__layout');
      if (formats || layout) {
        var wrap = doc.createElement('div');
        if (formats) wrap.appendChild(formats.cloneNode(true));
        if (layout) wrap.appendChild(layout.cloneNode(true));
        return wrap.innerHTML;
      }
    } catch (e) {}
    return null;
  }
  function loadCollectionView(href, push) {
    if (!href || _llcFetching) return false;
    var root = document.querySelector('[data-llc-root][data-section-id="' + ROOT_ID + '"]') || document.querySelector('[data-llc-root]');
    if (!root) return false;
    var target = absoluteUrl(href);
    /* ALWAYS A FULL NAVIGATION, and that is not laziness.

       This used to swap [data-llc-swap] in place and re-boot the section, and
       it was skipped entirely while the app owned filtering. Our own engine now
       owns the grid: it holds a reference to that element, the card it clones as
       a template, and the index it matches against. Swapping the grid out from
       under it leaves the engine filtering a node that is no longer on the page,
       so the panel goes dead while the server-rendered results sit there looking
       fine. The links that reach this are scope changes anyway (a different tag,
       a different page), which is a different set of products anddeserves a real
       navigation. Availability, the one thing shoppers toggle constantly, never
       reaches here: those chips drive the engine directly. */
    window.location.assign(target);
    return false;
  }

  /* ANCHORS ARE LEFT ALONE NOW.

     This used to intercept clicks on the chips, the pager and the active-filter
     links, preventDefault them, and hand the href to loadCollectionView so it
     could swap the grid in place. loadCollectionView no longer swaps anything:
     it navigates, because the engine owns the grid and replacing it underneath
     leaves the engine holding a detached node.

     So every interception here had become "cancel the link, then go to exactly
     where the link pointed" - no gain, and one real loss. preventDefault with
     no modifier-key guard kills ctrl-click and cmd-click, so opening a chip in
     a new tab silently navigated the current one instead. Letting the browser
     handle its own anchors fixes that for free.

     Availability chips never reached here anyway: llcAvailChips takes them in
     the capture phase and filters in place. */

  /* =====================================================================
     AVAILABILITY CHIPS DRIVE THE ENGINE, NOT THE SERVER

     The chips above the grid are real anchors to server-filtered URLs, so
     they work with JS off and stay crawlable. With JS on there is no reason
     to make the shopper wait for a page: the filter engine already holds the
     whole collection in memory and already owns an Availability facet with
     exactly these three states. Ticking its box is instant and leaves the
     scroll position alone.

     Bound in the capture phase, so the chip filters in place rather than
     following its own href.

     Falls through to the href whenever the engine is not there to drive:
     still booting, stood down, or a browser old enough to lack the panel. A
     chip that silently did nothing would be worse than a page load.
  ===================================================================== */
  function llcAvailChips(e) {
    if (!e.target || !e.target.closest) return;
    var chip = e.target.closest('[data-llc-avail-chip]');
    if (!chip) return;

    var panel = document.querySelector('.llf');
    if (!panel) return;                       /* engine absent: let it navigate */

    var want = chip.getAttribute('data-llc-avail-chip');
    var boxes = panel.querySelectorAll('[data-llf-avail]');
    if (!boxes.length) return;

    e.preventDefault();
    e.stopPropagation();
    if (e.stopImmediatePropagation) e.stopImmediatePropagation();

    /* "All" clears the facet; the others are exclusive, because that is what
       a chip row reads as. The panel itself stays multi-select for anyone who
       wants In stock and Coming soon together. */
    for (var i = 0; i < boxes.length; i++) {
      var box = boxes[i];
      var shouldBeOn = want !== 'all' && box.getAttribute('data-llf-avail') === want;
      if (box.checked !== shouldBeOn) {
        box.checked = shouldBeOn;
        box.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    /* The chips paint themselves from the panel rather than from the click, so
       the two cannot disagree if the shopper then uses the panel directly. */
    llcSyncAvailChips();
  }

  function llcSyncAvailChips() {
    var panel = document.querySelector('.llf');
    if (!panel) return;
    var on = [];
    panel.querySelectorAll('[data-llf-avail]').forEach(function (b) {
      if (b.checked) on.push(b.getAttribute('data-llf-avail'));
    });
    document.querySelectorAll('[data-llc-avail-chip]').forEach(function (chip) {
      var v = chip.getAttribute('data-llc-avail-chip');
      var active = v === 'all' ? on.length === 0 : (on.length === 1 && on[0] === v);
      chip.classList.toggle('is-on', active);
      if (active) chip.setAttribute('aria-current', 'page');
      else chip.removeAttribute('aria-current');
    });
  }

  if (window.__llcAvailChipHandler) {
    document.removeEventListener('click', window.__llcAvailChipHandler, true);
  }
  window.__llcAvailChipHandler = llcAvailChips;
  document.addEventListener('click', llcAvailChips, true);

  /* The engine announces every render, including the first. That is the moment
     the panel exists and the moment its state can have changed from under the
     chips, so it is the only signal they need. */
  document.addEventListener('ll:filter:rendered', llcSyncAvailChips);

  /* NO popstate HANDLER.

     This used to call loadCollectionView on back and forward so the swapped
     grid could be rebuilt. Now that loadCollectionView navigates, the same call
     asked the browser to re-assign the URL it had just restored: back worked,
     but paid for a full extra reload every time. The browser restores the
     previous page perfectly well on its own. */

  window.LLCollection = {
    watch: function (el) {
      try { return toggleWatch(el); } catch (e) { console && console.error && console.error('[LLC] watch', e); return false; }
    },
    atc: function (btn) {
      try { return addToCart(btn); } catch (e) { console && console.error && console.error('[LLC] atc', e); return false; }
    },
    paint: paintWatch,
    fetch: loadCollectionView
  };

  var _llcBusy = false;
  function withBusy(fn) {
    if (_llcBusy) return false;
    _llcBusy = true;
    try { return fn(); } finally { setTimeout(function () { _llcBusy = false; }, 400); }
  }

  document.addEventListener('click', function (e) {
    var atc = closestEl(e.target, '[data-llc-root] [data-atc]');
    if (atc && !atc.disabled) {
      e.preventDefault();
      e.stopPropagation();
      if (e.stopImmediatePropagation) e.stopImmediatePropagation();
      withBusy(function () { addToCart(atc); });
      return;
    }
    var watchBtn = closestEl(e.target, '[data-llc-root] [data-watch-cta], [data-llc-root] .llc__bell[data-watch]');
    if (!watchBtn) return;
    e.preventDefault();
    e.stopPropagation();
    if (e.stopImmediatePropagation) e.stopImmediatePropagation();
    withBusy(function () { toggleWatch(watchBtn); });
  }, true);

  document.addEventListener('submit', function (e) {
    var form = closestEl(e.target, '[data-coll-search]');
    if (!form || !closestEl(form, '[data-llc-root]')) return;
    var input = form.querySelector('[data-coll-q]');
    if (!input) return;
    var q = (input.value || '').trim();
    e.preventDefault();
    /* With the filter engine up, Search narrows THIS collection (every page
       of it, not just the cards on screen). It used to open the first
       suggestion, which on a Pokemon shelf could be a Lorcana card. */
    if (window.LLFilterUI && window.LLFilterUI.ready()) {
      window.LLFilterUI.search(q);
      var sg = form.parentNode && form.parentNode.querySelector('[data-suggest]');
      if (sg) sg.hidden = true;
      input.blur();
      return;
    }
    if (!q) return;
    /* Stay on collection: filter this page + open predictive matches. No collection: search syntax. */
    var root = rootOf(form);
    if (root && typeof root._llcApplyFilter === 'function') {
      root._llcQuery = q.toLowerCase();
      root._llcApplyFilter();
    }
    var first = form.parentNode && form.parentNode.querySelector('[data-suggest] a[href]');
    if (first) {
      window.location.href = first.getAttribute('href');
      return;
    }
    window.location.href = cartRootUrl() + 'search?type=product&q=' + encodeURIComponent(q);
  }, true);


  /* ---------------------------------------------------------------------
     Featured rails become a carousel on phones. It advances on its own so a
     shopper who does not swipe still sees the whole rail, and it hands over
     the moment they touch it: any real input stops it for good rather than
     fighting the finger. Scroll events are deliberately NOT a stop signal,
     because the smooth scroll it performs itself fires those too.
  --------------------------------------------------------------------- */
  function initFeaturedRails(root) {
    var rails = [].slice.call(root.querySelectorAll('[data-feat-rail]'));
    if (!rails.length) return function () {};

    var isPhone = window.matchMedia('(max-width: 820px)');
    var stillPlease = window.matchMedia('(prefers-reduced-motion: reduce)');
    var teardown = [];

    rails.forEach(function (rail) {
      var cards = [].slice.call(rail.querySelectorAll('.llc__fcard'));
      var dots = rail.parentElement.querySelector('[data-feat-dots]');
      var wait = (parseFloat(rail.getAttribute('data-feat-autoplay')) || 0) * 1000;
      var timer = null;
      var handedOver = false;
      var onScreen = true;

      if (cards.length < 2) return;

      if (dots) {
        dots.innerHTML = '';
        cards.forEach(function () { dots.appendChild(document.createElement('b')); });
      }

      function step() {
        var first = cards[0].getBoundingClientRect().width;
        var gap = parseFloat(getComputedStyle(rail).columnGap || getComputedStyle(rail).gap) || 0;
        return first + gap;
      }

      function paintDots() {
        if (!dots) return;
        var w = step();
        var i = w ? Math.round(rail.scrollLeft / w) : 0;
        if (i > cards.length - 1) i = cards.length - 1;
        if (i < 0) i = 0;
        for (var n = 0; n < dots.children.length; n++) {
          dots.children[n].setAttribute('data-on', n === i ? '1' : '0');
        }
      }

      function pause() { if (timer) { clearInterval(timer); timer = null; } }

      function handOver() {
        handedOver = true;
        pause();
      }

      function advance() {
        if (!isPhone.matches || document.hidden || !onScreen) return;
        var end = rail.scrollWidth - rail.clientWidth;
        var next = rail.scrollLeft + step();
        /* Stop on the end before wrapping. Jumping straight back from the
           second-to-last position means the final card is only ever half in
           view and its dot never lights. */
        if (next > end - 2) next = (rail.scrollLeft >= end - 2) ? 0 : end;
        try { rail.scrollTo({ left: next, behavior: 'smooth' }); }
        catch (e) { rail.scrollLeft = next; }
      }

      function play() {
        pause();
        if (handedOver || !wait || !isPhone.matches || stillPlease.matches) return;
        timer = setInterval(advance, wait);
      }

      function reflow() {
        var carousel = isPhone.matches;
        if (dots) dots.hidden = !carousel;
        if (!carousel) { pause(); rail.scrollLeft = 0; }
        else { paintDots(); play(); }
      }

      /* Anything the shopper actually does ends the auto-advance. */
      ['touchstart', 'pointerdown', 'wheel', 'keydown'].forEach(function (ev) {
        rail.addEventListener(ev, handOver, { passive: true });
        teardown.push(function () { rail.removeEventListener(ev, handOver); });
      });
      rail.addEventListener('focusin', handOver);
      teardown.push(function () { rail.removeEventListener('focusin', handOver); });

      var onRailScroll = throttleFrame(paintDots);
      rail.addEventListener('scroll', onRailScroll, { passive: true });
      teardown.push(function () { rail.removeEventListener('scroll', onRailScroll); });

      /* A rail nobody can see should not be spending frames. */
      if (window.IntersectionObserver) {
        var io = new IntersectionObserver(function (entries) {
          onScreen = entries[0].isIntersecting;
          if (onScreen) play(); else pause();
        }, { threshold: 0.25 });
        io.observe(rail);
        teardown.push(function () { io.disconnect(); });
      }

      var onHide = function () { if (document.hidden) pause(); else play(); };
      document.addEventListener('visibilitychange', onHide);
      teardown.push(function () { document.removeEventListener('visibilitychange', onHide); });

      var onBreak = function () { reflow(); };
      if (isPhone.addEventListener) isPhone.addEventListener('change', onBreak);
      else if (isPhone.addListener) isPhone.addListener(onBreak);
      teardown.push(function () {
        if (isPhone.removeEventListener) isPhone.removeEventListener('change', onBreak);
        else if (isPhone.removeListener) isPhone.removeListener(onBreak);
      });

      teardown.push(pause);
      reflow();
    });

    return function () { teardown.forEach(function (fn) { try { fn(); } catch (e) {} }); };
  }

  function throttleFrame(fn) {
    var queued = false;
    return function () {
      if (queued) return;
      queued = true;
      requestAnimationFrame(function () { queued = false; fn(); });
    };
  }

  function boot(root) {
    if (!root || root.dataset.llcReady === '1') return;
    root.dataset.llcReady = '1';
    root.setAttribute('data-llc-js', '1');

    /* Availability is exclusive — stacked ?availability=1&availability=0 is invalid. */
    try {
      var availUrl = new URL(window.location.href);
      var availVals = availUrl.searchParams.getAll('filter.v.availability');
      if (availVals.indexOf('1') !== -1 && availVals.indexOf('0') !== -1) {
        availUrl.searchParams.delete('filter.v.availability');
        window.location.replace(availUrl.pathname + availUrl.search + availUrl.hash);
        return;
      }
    } catch (eAvail) {}

    /* Zero in-stock → default to Out of stock (pending / pre-order releases). */
    try {
      var autoOos = root.getAttribute('data-llc-auto-oos');
      if (autoOos) {
        var dest = new URL(autoOos, window.location.origin);
        var cur = new URL(window.location.href);
        var curAvail = cur.searchParams.getAll('filter.v.availability');
        if (curAvail.indexOf('0') === -1) {
          window.location.replace(dest.pathname + dest.search + dest.hash);
          return;
        }
      }
    } catch (eAuto) {}

    var live = root.querySelector('[data-live]');
    var toast = root.querySelector('[data-toast]');
    ensureToast(root);
    var filter = 'all';
    var format = 'all';
    var query = '';
    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-card]'));
    var empty = root.querySelector('[data-empty]');
    var shown = root.querySelector('[data-shown-count]');
    var watchChip = root.querySelector('[data-watch-chip]');

    function say(msg) { if (live) live.textContent = msg; }

    function refreshCounts() {
      var watched = readWatch();
      var total = watched.length;
      var watchPage = root.querySelector('[data-watch-page-link] [data-chip-n]');
      if (watchPage) watchPage.textContent = total ? ' ' + total : '';
      var watchPageLink = root.querySelector('[data-watch-page-link]');
      if (watchPageLink) {
        watchPageLink.hidden = total === 0;
        watchPageLink.style.display = total ? '' : 'none';
      }
    }

    function applyFilter() {
      var q = (root._llcQuery != null ? root._llcQuery : query) || '';
      var n = 0;
      cards.forEach(function (card) {
        var st = card.getAttribute('data-state') || '';
        var fmt = card.getAttribute('data-format') || '';
        var ok = true;
        if (filter === 'instock') ok = st === 'instock' || st === 'preorder';
        else if (filter === 'soldout') ok = st === 'soldout';
        else if (filter === 'preorder') {
          /* State only: it already reads the pre-order tag up to release day,
             and after it a tagged card is simply In Stock or Sold Out. */
          ok = st === 'preorder' || st === 'coming' || st === 'pending';
        }
        else if (filter === 'coming') ok = st === 'coming';
        else if (filter === 'pending') ok = st === 'pending';
        if (ok && format !== 'all') ok = fmt === format;
        if (ok && q) ok = (card.getAttribute('data-search') || '').indexOf(q) > -1;
        card.hidden = !ok;
        if (ok) n++;
      });
      if (empty) empty.setAttribute('data-show', n === 0 ? '1' : '0');
      if (shown) shown.textContent = String(n);
      refreshCounts();
    }
    root._llcApplyFilter = applyFilter;

    function setStockFilter(key) {
      filter = key || 'all';
      root.setAttribute('data-watching-filter', '0');
      root.querySelectorAll('[data-stock-filter]').forEach(function (el) {
        var on = el.getAttribute('data-stock-filter') === filter;
        el.setAttribute('aria-pressed', on ? 'true' : 'false');
        if (on) el.classList.add('is-on');
        else el.classList.remove('is-on');
      });
      applyFilter();
    }

    function setFormatFilter(key) {
      format = key || 'all';
      root.querySelectorAll('[data-format-filter]').forEach(function (el) {
        var on = el.getAttribute('data-format-filter') === format;
        el.setAttribute('aria-pressed', on ? 'true' : 'false');
        if (on) el.classList.add('is-on');
        else el.classList.remove('is-on');
      });
      applyFilter();
    }

    root.addEventListener('click', function (e) {
      var tip = closestEl(e.target, '[data-watch-tip-dismiss]');
      if (tip && root.contains(tip)) {
        try { localStorage.setItem('ll_watchlist_tip_seen', '1'); } catch (err) {}
        document.querySelectorAll('[data-watch-tip]').forEach(function (el) { el.hidden = true; });
        return;
      }
      var busy = closestEl(e.target, '[data-busy-dismiss]');
      if (busy && root.contains(busy)) {
        try { sessionStorage.setItem('ll_busy_banner', '1'); } catch (err) {}
        var note = root.querySelector('[data-busy-note]');
        if (note) note.hidden = true;
        return;
      }
      var scrollBtn = closestEl(e.target, '[data-scroll]');
      if (scrollBtn && root.contains(scrollBtn)) {
        var el = document.querySelector(scrollBtn.getAttribute('data-scroll'));
        if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
        return;
      }
      var reset = closestEl(e.target, '[data-reset-filters]');
      if (reset && root.contains(reset)) {
        filter = 'all';
        query = '';
        root.setAttribute('data-watching-filter', '0');
        var search = root.querySelector('[data-search]');
        if (search) search.value = '';
        if (watchChip) watchChip.setAttribute('aria-pressed', 'false');
        applyFilter();
        return;
      }
      var stockBtn = closestEl(e.target, '[data-stock-filter]');
      if (stockBtn && root.contains(stockBtn)) {
        e.preventDefault();
        var sk = stockBtn.getAttribute('data-stock-filter') || 'all';
        if (filter === sk && sk !== 'all') sk = 'all';
        setStockFilter(sk);
        return;
      }
      var formatBtn = closestEl(e.target, 'button[data-format-filter]');
      if (formatBtn && root.contains(formatBtn)) {
        e.preventDefault();
        var fk = formatBtn.getAttribute('data-format-filter') || 'all';
        if (format === fk && fk !== 'all') fk = 'all';
        setFormatFilter(fk);
        return;
      }
    });

    if (watchChip) {
      watchChip.addEventListener('click', function () {
        if (watchChip.getAttribute('data-has') !== '1') return;
        var watchUrl = root.getAttribute('data-watch-url') || '/pages/watchlist';
        window.location.href = watchUrl;
      });
    }

    var search = root.querySelector('[data-search]');
    if (search) {
      search.addEventListener('input', function () {
        query = (search.value || '').trim().toLowerCase();
        applyFilter();
      });
    }

    var filtersEl = root.querySelector('[data-filters]');

    /* The page scroll lock is DERIVED from whether the sheet is open, never
       set and unset by hand at two call sites.

       It used to be the latter, and it stranded shoppers. Applying an XCloud
       filter navigates the browser WITHOUT swapping the document: the URL
       goes from /collections/pokemon to /a/search/pokemon?filter_... and the
       results re-render in place. The sheet markup is replaced underneath us,
       so its is-open class disappears, but nothing calls closeFilters() and
       the inline overflow: hidden on <html> survives. The sheet looked shut
       and the page could not be scrolled, with no control left on screen able
       to release it. A real page load would have cleared it; a soft one does
       not.

       Reading the state instead means the lock cannot outlive the thing it
       belongs to: whenever the sheet is not open, the lock is off. */
    /* Elements are looked up per call, never captured once.

       Re-rendering this section in place throws
       away the sheet, the backdrop and the Filters button and builds new ones.
       Anything holding a reference from page load is then pointing at detached
       markup: the sheet the shopper sees is not the sheet the script is
       toggling. Measured after applying one filter, the Filters button was
       still on screen and completely dead, so there was no way back to the
       filters to refine or clear them. */
    function sheetEl() { return document.querySelector('[data-filters]'); }
    function backdropEl() { return document.querySelector('[data-filters-backdrop]'); }
    function sheetIsOpen() {
      var el = sheetEl();
      return !!(el && el.classList.contains('is-open'));
    }
    function syncScrollLock() {
      document.documentElement.style.overflow = sheetIsOpen() ? 'hidden' : '';
    }

    function openFilters() {
      var el = sheetEl();
      if (!el) return;
      el.classList.add('is-open');
      var bd = backdropEl();
      if (bd) { bd.hidden = false; bd.classList.add('is-on'); }
      syncScrollLock();
    }
    function closeFilters() {
      var el = sheetEl();
      if (el) el.classList.remove('is-open');
      var bd = backdropEl();
      if (bd) { bd.hidden = true; bd.classList.remove('is-on'); }
      syncScrollLock();
    }

    /* One delegated listener rather than a binding per button, for the same
       reason: a listener attached to a button does not survive that button
       being replaced, and these are replaced on every filter applied. */
    document.addEventListener('click', function (e) {
      var t = e.target;
      if (!t || !t.closest) return;
      if (t.closest('[data-filters-open]')) { openFilters(); return; }
      if (t.closest('[data-filters-close]') || t.closest('[data-filters-backdrop]')) { closeFilters(); }
    });

    /* Safety net for every other way the page can change under the sheet. A
       soft navigation fires no load event, so the lock is re-derived whenever
       history moves or the section re-renders. Cheap: one string write, and
       only when something actually changed. */
    window.addEventListener('popstate', syncScrollLock);
    window.addEventListener('pageshow', syncScrollLock);
    if (window.MutationObserver) {
      var lockPending;
      new MutationObserver(function () {
        clearTimeout(lockPending);
        lockPending = setTimeout(syncScrollLock, 80);
      }).observe(root, { childList: true, subtree: true });
    }

    var tipEl = root.querySelector('[data-watch-tip]');
    try {
      if (tipEl && localStorage.getItem('ll_watchlist_tip_seen') !== '1') tipEl.hidden = false;
    } catch (e) {}
    var busyEl = root.querySelector('[data-busy-note]');
    try {
      if (busyEl && sessionStorage.getItem('ll_busy_banner') === '1') busyEl.hidden = true;
    } catch (e) {}

    document.addEventListener('ll:watchlist:change', function () { paintWatch(root); });

    /* Same reason the search page listens: the filter engine replaces the grid
       with clones that carry no watchlist state, and announces each render so
       the page can put it back. Without this a bell for a watched product came
       back unlit after any filter or sort. */
    document.addEventListener('ll:filter:rendered', function () { paintWatch(root); });
    window.addEventListener('storage', function (e) {
      if (!e.key) return;
      if (e.key === WKEY || e.key === WKEY_LEGACY || e.key.indexOf('ll_watchlist_c_') === 0) paintWatch(root);
    });

    /* Discord live count + dismiss */
    (function () {
      var bar = root.querySelector('[data-llc-discord]');
      if (!bar) return;
      var discKey = 'll_discord_bar_dismissed';
      try {
        if (bar.getAttribute('data-discord-dismissible') === '1' && localStorage.getItem(discKey) === '1') {
          bar.hidden = true;
        }
      } catch (err) {}
      var dismissBtn = bar.querySelector('[data-discord-dismiss]');
      if (dismissBtn) {
        dismissBtn.addEventListener('click', function () {
          bar.hidden = true;
          try { localStorage.setItem(discKey, '1'); } catch (err2) {}
        });
      }
      var out = bar.querySelector('[data-disc-online]');
      var id = bar.getAttribute('data-server-id');
      if (!id || !out) return;
      /* The band sits below the grid now, so its live count waits until the
         shopper is near it rather than costing every page view a request. */
      var asked = false;
      var ask = function () {
        if (asked) return;
        asked = true;
        fetch('https://discord.com/api/guilds/' + id + '/widget.json')
          .then(function (r) { if (!r.ok) throw new Error('widget off'); return r.json(); })
          .then(function (d) {
            var n = typeof d.presence_count === 'number' ? d.presence_count : null;
            out.textContent = n === null ? 'Live' : n.toLocaleString();
          })
          .catch(function () { out.textContent = 'Live'; });
      };
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (en) {
          if (en[0] && en[0].isIntersecting) { io.disconnect(); ask(); }
        }, { rootMargin: '400px 0px' });
        io.observe(bar);
      } else {
        ask();
      }
    })();

    /* Brand advert dismiss (per block id) */
    root.querySelectorAll('[data-llc-ad][data-ad-dismissible="1"]').forEach(function (ad) {
      var id = ad.getAttribute('data-ad-id') || '';
      var key = 'll_ad_dismiss_' + id;
      try {
        if (id && localStorage.getItem(key) === '1') ad.hidden = true;
      } catch (err) {}
      var btn = ad.querySelector('[data-ad-dismiss]');
      if (!btn) return;
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        ad.hidden = true;
        try { if (id) localStorage.setItem(key, '1'); } catch (err2) {}
      });
    });

    /* Predictive search within collection (no collection: syntax) */
    var searchForm = root.querySelector('[data-coll-search]');
    var suggestEl = root.querySelector('[data-suggest]');
    var searchInput = root.querySelector('[data-coll-q]');
    var suggestTimer = null;
    /* A shared ?q= link: show the words in the box straight away. The results
       follow once the filter index has loaded, which on a slow phone is a few
       seconds; an empty box over a full, dimmed grid read as a broken link. */
    if (searchInput && !searchInput.value) {
      try {
        var sharedQ = (new URLSearchParams(location.search).get('q') || '').trim();
        if (sharedQ) searchInput.value = sharedQ;
      } catch (e) {}
    }
    function renderSuggest(items) {
      if (!suggestEl) return;
      if (!items || !items.length) {
        suggestEl.innerHTML = '<div class="llc__suggest-empty">No matches in suggestions. Press Search to look across the store.</div>';
        suggestEl.hidden = false;
        return;
      }
      suggestEl.innerHTML = items.map(function (it) {
        var img = it.image || '';
        var price = it.price || '';
        return '<a href="' + it.url + '">' +
          (img ? '<img src="' + img + '" alt="">' : '<span></span>') +
          '<span><b>' + it.title + '</b><span>' + price + '</span></span></a>';
      }).join('');
      suggestEl.hidden = false;
    }
    /* ---- search within THIS collection, through the filter index ----------
       Shopify's predictive search is store wide, so a Pokemon shelf suggested
       Lorcana's Peter Pan. The filter engine holds exactly this collection's
       products (every game, every set page), so once it is up, suggestions
       and the Search button both come from it. The store-wide path below is
       kept only for when the engine is not available. */
    function engineOn() { return !!(window.LLFilterUI && window.LLFilterUI.ready() && window.LLFilter && window.LLFilter.find); }
    var sgCache = {};
    function productJson(h) {
      if (!sgCache[h]) {
        sgCache[h] = fetch(cartRootUrl() + 'products/' + h + '.js', { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.ok ? r.json() : null; })
          .catch(function () { return null; });
      }
      return sgCache[h];
    }
    function esc(t) { return String(t == null ? '' : t).replace(/[&<>"']/g, function (c) { return '&#' + c.charCodeAt(0) + ';'; }); }
    function money(p) { return '\u00A3' + (Number(p || 0) / 100).toFixed(2); }
    var sgSeq = 0;
    function runEngineSuggest(q) {
      var seq = ++sgSeq;
      var all = window.LLFilter.find(q);
      var title = (root.querySelector('.llc__title') || {}).textContent || 'this collection';
      if (!all.length) {
        suggestEl.innerHTML = '<div class="llc__suggest-empty">Nothing in ' + esc(title.trim()) + ' matches \u201c' + esc(q) + '\u201d.</div>';
        suggestEl.hidden = false;
        return;
      }
      Promise.all(all.slice(0, 6).map(productJson)).then(function (list) {
        if (seq !== sgSeq) return;
        var html = list.filter(Boolean).map(function (p) {
          var img = p.featured_image ? String(p.featured_image).replace(/^\/\//, 'https://') : '';
          if (img) img += (img.indexOf('?') > -1 ? '&' : '?') + 'width=96';
          var price = p.available === false ? 'Sold out' : (p.price_varies ? 'From ' : '') + money(p.price);
          return '<a href="' + esc(p.url || ('/products/' + p.handle)) + '">' +
            (img ? '<img src="' + esc(img) + '" alt="" loading="lazy" width="40" height="40">' : '<span></span>') +
            '<span><b>' + esc(p.title) + '</b><span>' + esc(price) + '</span></span></a>';
        }).join('');
        html += '<button type="button" class="llc__suggest-all" data-suggest-all>See all ' + all.length.toLocaleString('en-GB') +
          ' result' + (all.length === 1 ? '' : 's') + ' in ' + esc(title.trim()) + '</button>';
        suggestEl.innerHTML = html;
        suggestEl.hidden = false;
      });
    }
    function submitSearch(q) {
      if (!engineOn()) return false;
      window.LLFilterUI.search(q);
      if (suggestEl) suggestEl.hidden = true;
      if (searchInput) searchInput.blur();
      var bar = root.querySelector('.llc__toolbar');
      if (bar && bar.getBoundingClientRect().top < 0) {
        window.scrollTo({ top: bar.getBoundingClientRect().top + window.scrollY - (parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-height')) || 0), behavior: 'smooth' });
      }
      return true;
    }
    if (searchForm) {
      searchForm.addEventListener('submit', function (e) {
        if (submitSearch(searchInput ? searchInput.value : '')) e.preventDefault();
      });
    }
    if (suggestEl) {
      suggestEl.addEventListener('click', function (e) {
        if (!closestEl(e.target, '[data-suggest-all]')) return;
        submitSearch(searchInput ? searchInput.value : '');
      });
    }

    function runSuggest(q) {
      if (!q || q.length < 2) {
        if (suggestEl) suggestEl.hidden = true;
        /* An emptied box clears the search it had applied. */
        if (engineOn() && !q && window.LLFilterUI.selection().q) window.LLFilterUI.search('');
        return;
      }
      if (engineOn() && suggestEl) { runEngineSuggest(q); return; }
      var url = cartRootUrl() + 'search/suggest.json?q=' + encodeURIComponent(q) +
        '&resources[type]=product&resources[limit]=8&resources[options][fields]=title,product_type,vendor,tag';
      fetch(url, { headers: { 'Accept': 'application/json' }, credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var products = (((data || {}).resources || {}).results || {}).products || [];
          var handle = (root.getAttribute('data-coll-handle') || '').toLowerCase();
          var typeHint = (root.getAttribute('data-type-hint') || '').toLowerCase();
          var items = [];
          products.forEach(function (p) {
            var title = p.title || '';
            var ptype = (p.product_type || '').toLowerCase();
            var tags = (p.tags || []).join(',').toLowerCase();
            var url = p.url || '';
            var ok = true;
            if (typeHint) ok = ptype.indexOf(typeHint) > -1 || tags.indexOf(typeHint) > -1 || title.toLowerCase().indexOf(typeHint) > -1;
            if (handle && url.indexOf('/collections/' + handle) > -1) ok = true;
            if (!ok && typeHint) return;
            items.push({
              title: title,
              url: url,
              image: (p.image || p.featured_image || ''),
              price: p.price || ''
            });
          });
          renderSuggest(items.slice(0, 8));
        })
        .catch(function () { if (suggestEl) suggestEl.hidden = true; });
    }
    if (searchInput) {
      searchInput.addEventListener('input', function () {
        query = (searchInput.value || '').trim().toLowerCase();
        root._llcQuery = query;
        /* Hiding cards on screen by text is only for when the engine is off;
           with it on, the search runs across the whole collection instead. */
        if (!engineOn()) applyFilter();
        clearTimeout(suggestTimer);
        suggestTimer = setTimeout(function () { runSuggest(searchInput.value.trim()); }, 220);
      });
      searchInput.addEventListener('focus', function () {
        if ((searchInput.value || '').trim().length >= 2) runSuggest(searchInput.value.trim());
      });
    }
    document.addEventListener('click', function (e) {
      if (!suggestEl || suggestEl.hidden) return;
      if (closestEl(e.target, '[data-search-root]')) return;
      suggestEl.hidden = true;
    });

    var stopFeaturedRails = initFeaturedRails(root);

    paintWatch(root);
    applyFilter();
    say('Collection ready');
    try { console.info('[LLC] collection ready', ROOT_ID); } catch (e) {}

    root.llcDestroy = function () {
      root.dataset.llcReady = '';
      try { stopFeaturedRails(); } catch (eRail) {}
      root.removeAttribute('data-llc-js');
      try { if (root._llcAvailMo) root._llcAvailMo.disconnect(); } catch (eMo) {}
      root._llcAvailMo = null;
      var t = document.querySelector('.llc-toast-' + ROOT_ID);
      if (t && t.parentNode === document.body) t.remove();
    };
  }

  function find() {
    return document.querySelector('[data-llc-root][data-section-id="' + ROOT_ID + '"]') || document.querySelector('[data-llc-root]');
  }
  function start() { boot(find()); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
  document.addEventListener('shopify:section:load', function (e) {
    if (String(e.detail.sectionId) !== String(ROOT_ID)) return;
    start();
  });
  document.addEventListener('shopify:section:unload', function (e) {
    if (String(e.detail.sectionId) !== String(ROOT_ID)) return;
    var el = find();
    if (el && el.llcDestroy) el.llcDestroy();
  });
})();


/* ==========================================================================
   Part 2: the 2026 collection page
   ========================================================================== */
(function () {
  'use strict';

  var KEY_VIEW = 'll_coll_view';
  var ICON_X = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M18 6 6 18"/></svg>';

  function fmt(n) { return Number(n || 0).toLocaleString('en-GB'); }

  function boot(root) {
    if (!root || root.__llc26) return;
    root.__llc26 = true;

    /* ---- grid or list ---------------------------------------------------- */
    var viewBtns = root.querySelectorAll('[data-llc-view]');
    function setView(v, save) {
      if (v === 'list') root.setAttribute('data-llc-view', 'list');
      else root.removeAttribute('data-llc-view');
      viewBtns.forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-llc-view') === (v === 'list' ? 'list' : 'grid') ? 'true' : 'false'); });
      if (save) { try { localStorage.setItem(KEY_VIEW, v === 'list' ? 'list' : 'grid'); } catch (e) {} }
    }
    setView(root.getAttribute('data-llc-view') === 'list' ? 'list' : 'grid', false);
    viewBtns.forEach(function (b) {
      b.addEventListener('click', function () { setView(b.getAttribute('data-llc-view'), true); });
    });

    /* ---- description: read more when it is clamped ------------------------ */
    var sub = root.querySelector('[data-llc-sub]');
    if (sub && sub.scrollHeight > sub.clientHeight + 2) {
      var more = document.createElement('button');
      more.type = 'button';
      more.className = 'llc__more-desc';
      more.textContent = 'Read more';
      more.setAttribute('aria-expanded', 'false');
      more.addEventListener('click', function () {
        var open = sub.classList.toggle('is-open');
        more.textContent = open ? 'Show less' : 'Read more';
        more.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
      sub.parentNode.insertBefore(more, sub.nextSibling);
    }

    /* ---- the set drawer --------------------------------------------------- */
    var cl = root.querySelector('#card-list');
    var setsBtn = root.querySelector('[data-llc-sets]');
    var toggle = cl && cl.querySelector('.llcl__toggle');
    var lastFocus = null;
    function drawerOpen() { return !!(toggle && toggle.checked); }
    function setDrawer(open) {
      if (!toggle) return;
      if (open === drawerOpen()) return;
      toggle.checked = open;
      toggle.dispatchEvent(new Event('change', { bubbles: true }));
    }
    if (cl && toggle && setsBtn) {
      setsBtn.hidden = false;
      setsBtn.setAttribute('aria-controls', 'card-list');
      var head = cl.querySelector('.llcl__head');
      if (head && !head.querySelector('.llcl__x')) {
        var x = document.createElement('button');
        x.type = 'button';
        x.className = 'llcl__x';
        x.setAttribute('aria-label', 'Close set checklists');
        x.innerHTML = ICON_X;
        x.addEventListener('click', function () { setDrawer(false); });
        head.appendChild(x);
      }
      var panelEl = cl.querySelector('.llcl__panel');
      if (panelEl) {
        panelEl.setAttribute('role', 'dialog');
        panelEl.setAttribute('aria-modal', 'true');
        panelEl.setAttribute('aria-labelledby', 'llcl-h');
        panelEl.setAttribute('tabindex', '-1');
      }
      setsBtn.addEventListener('click', function () {
        lastFocus = setsBtn;
        setDrawer(true);
      });
      toggle.addEventListener('change', function () {
        var open = toggle.checked;
        document.documentElement.classList.toggle('llc-lock', open);
        setsBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (open && panelEl) {
          setTimeout(function () { try { panelEl.focus({ preventScroll: true }); } catch (e) { panelEl.focus(); } }, 40);
        } else if (!open && lastFocus) {
          try { lastFocus.focus({ preventScroll: true }); } catch (e) {}
        }
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && drawerOpen()) { e.preventDefault(); setDrawer(false); }
      });

      /* "Show cards": narrow the grid to one set through the filter engine. */
      cl.addEventListener('click', function (e) {
        var go = e.target.closest && e.target.closest('[data-llcl-go]');
        if (!go) return;
        e.preventDefault();
        e.stopPropagation();
        var ui = window.LLFilterUI;
        if (!ui || !ui.ready()) return;
        ui.select('set_name', [go.getAttribute('data-llcl-go')]);
        setDrawer(false);
        var bar = root.querySelector('.llc__toolbar');
        if (bar) {
          var y = bar.getBoundingClientRect().top + window.scrollY - (parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-height')) || 0) - 8;
          window.scrollTo({ top: Math.max(0, y), behavior: 'smooth' });
        }
      });
    }
    /* Show cards needs the engine; without it the buttons would do nothing. */
    function syncGo() {
      var on = !!(window.LLFilterUI && window.LLFilterUI.ready());
      root.classList.toggle('llc--engine', on);
    }

    /* ---- engine state: pills, counts, masthead numbers ------------------- */
    var pills = root.querySelector('[data-llc-pills]');
    var filterN = root.querySelector('[data-llc-filter-n]');
    var statIn = root.querySelector('[data-llc-stat="in"]');
    var statSets = root.querySelector('[data-llc-stat="sets"]');
    var firstCounts = false;

    function optLabel(key, value) {
      var o = root.querySelector('.llf [data-llf-opts="' + key + '"] .llf__opt[data-value="' + (window.CSS && CSS.escape ? CSS.escape(value) : value) + '"] span');
      return o ? o.textContent : value;
    }
    function pill(text, onClear) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'llc__pill';
      b.innerHTML = '<span></span>' + ICON_X;
      b.firstChild.textContent = text;
      b.setAttribute('aria-label', 'Remove filter: ' + text);
      b.addEventListener('click', onClear);
      return b;
    }
    function clickIn(sel) {
      var el = root.querySelector(sel);
      if (el) el.click();
    }

    document.addEventListener('ll:filter:state', function (e) {
      syncGo();
      var d = e.detail || {};
      var sel = d.selection || {};

      if (filterN) {
        filterN.textContent = String(d.applied || 0);
        filterN.hidden = !d.applied;
      }

      /* The collection's own totals, taken from the first unfiltered answer. */
      if (!firstCounts && !d.applied && d.counts) {
        firstCounts = true;
        var av = d.counts.availability || {};
        /* Never contradict the total above it: the index can hold a product
           or two Shopify's own count does not, and "195 in stock" beside
           "193 products" is a number nobody should have to reconcile. */
        var total = parseInt(String((root.querySelector('.llc__stats li b') || {}).textContent || '0').replace(/[^0-9]/g, ''), 10) || 0;
        if (statIn && av.in > 0 && (!total || av.in <= total)) {
          statIn.querySelector('b').textContent = fmt(av.in);
          statIn.hidden = false;
        }
        var sets = d.counts.set_name || {};
        var nSets = 0;
        for (var k in sets) if (sets[k] > 0) nSets++;
        if (statSets && nSets > 1) {
          statSets.querySelector('b').textContent = fmt(nSets);
          statSets.hidden = false;
        }
      }

      if (!pills) return;
      pills.innerHTML = '';
      var n = 0;
      ['game', 'brand', 'product_class', 'series', 'set_name', 'language'].forEach(function (key) {
        (sel[key] || []).forEach(function (v) {
          n++;
          pills.appendChild(pill(optLabel(key, v), function () {
            clickIn('.llf [data-llf-opts="' + key + '"] .llf__opt[data-value="' + (window.CSS && CSS.escape ? CSS.escape(v) : v) + '"] input');
          }));
        });
      });
      var AV = { in: 'In stock', out: 'Out of stock', coming: 'Coming soon' };
      (sel.availability || []).forEach(function (a) {
        n++;
        pills.appendChild(pill(AV[a] || a, function () { clickIn('.llf [data-llf-avail="' + a + '"]'); }));
      });
      [['preorder', 'preorder', 'Pre-order only'], ['onSale', 'onsale', 'On offer'], ['newIn', 'newin', 'New in']].forEach(function (f) {
        if (!sel[f[0]]) return;
        n++;
        pills.appendChild(pill(f[2], function () { clickIn('.llf [data-llf-flag="' + f[1] + '"]'); }));
      });
      if (sel.q) {
        n++;
        pills.appendChild(pill('\u201c' + sel.q + '\u201d', function () {
          var box = root.querySelector('[data-coll-q]');
          if (box) box.value = '';
          if (window.LLFilterUI) window.LLFilterUI.search('');
        }));
      }
      var qBox = root.querySelector('[data-coll-q]');
      if (qBox && document.activeElement !== qBox) qBox.value = sel.q || '';
      if (sel.priceMin != null || sel.priceMax != null) {
        n++;
        var lo = sel.priceMin != null ? '£' + (sel.priceMin / 100).toFixed(2) : '£0';
        var hi = sel.priceMax != null ? '£' + (sel.priceMax / 100).toFixed(2) : 'any';
        pills.appendChild(pill(lo + ' to ' + hi, function () {
          var mn = root.querySelector('.llf [data-llf-price-min]');
          var mx = root.querySelector('.llf [data-llf-price-max]');
          if (mn) { mn.value = ''; mn.dispatchEvent(new Event('change', { bubbles: true })); }
          if (mx) { mx.value = ''; mx.dispatchEvent(new Event('change', { bubbles: true })); }
        }));
      }
      if (n > 1) {
        var all = document.createElement('button');
        all.type = 'button';
        all.className = 'llc__pill-clear';
        all.textContent = 'Clear all';
        all.addEventListener('click', function () { clickIn('.llf [data-llf-clear]'); });
        pills.appendChild(all);
      }
      pills.hidden = n === 0;
    });
  }

  function start() { document.querySelectorAll('[data-llc-root]').forEach(boot); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
  document.addEventListener('shopify:section:load', start);
})();
